import DocumentTitle from 'react-document-title';
import { useParams } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';

import { JobContextProvider } from 'hb-react/frontoffice/apps/JobsV2/contexts/JobContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import decodeString from 'hb-react/shared/utils/decodeString';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

import Actions from './Actions';
import Attachments from './Attachments';
import Author from './Author';
import Comments from './Comments';
import Description from './Description';
import Header from './Header';
import OtherInformation from './OtherInformation';

const JobDetails = ({
  dataTestId,
  job,
  noBorderRadiusOnSmallScreen,
  urls,
  topic,
}) => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const { opportunityId } = useParams();

  if (!job) return null;

  return (
    <>
      {/* Only if the job is selected */}
      {opportunityId && (
        <DocumentTitle
          title={generatePageTitle({
            title: decodeString(job.title),
            networkName: getPageTitleFromNetwork(currentNetwork),
            topicName: topic?.name,
          })}
        />
      )}
      <JobContextProvider job={job}>
        <Card
          noBorderRadiusOnSmallScreen={noBorderRadiusOnSmallScreen}
          data-testid={dataTestId}
        >
          <Box flexDirection="column" alignItems="stretch">
            <Header urls={urls} />
            <Actions />
            {currentUser && <Author />}
            <Description />
            <Attachments />
            <OtherInformation />
            {/* <About /> */}
            {currentUser && <Comments urls={urls} />}
          </Box>
        </Card>
      </JobContextProvider>
    </>
  );
};

export default JobDetails;
